import React, { useEffect, useState, useCallback } from 'react';
import { useDrag } from 'react-dnd'

/**
 * Custom DnD implemented component
 * @param {Object} props 
 */
const DraggableComponent = (props) => {
  const { type, prefix_type, onDragStart, onDragEnd, children, messageIndex, rowIndex, rowIndexDetail, componentIndex, cat_type, disableDrag } = props
  // optional
  const { handleWrapCSS, contentWrapCSS, renderedHeight, dragHandle, contentHeight, verticalHandle, contentWidth, verticalLeftAreaCSS } = props
  
  const [ _renderedHeight, setRenderedHeight ] = useState()
  const dragContentRef = useCallback((node) => {
    if (node) {
      setRenderedHeight(node.offsetHeight)
    }
  }, [])

  // binding properties to useDrag.item
  const drop_items = {
    messageIndex: messageIndex,
    rowIndex: rowIndex,
    componentIndex: componentIndex,
    rowIndexDetail: rowIndexDetail,
    cat_type: cat_type,
  }
  
  const [{isDragging}, drag, preview] = useDrag({
    item: { type: type, prefix_type: prefix_type, ...drop_items },
    collect: monitor => ({
      isDragging: !!monitor.isDragging(),
    })
  })

  useEffect(() => {
    const param = {
      type: type
    }
    if ( isDragging ) {
      onDragStart(param)
    } else {
      onDragEnd(param)
    }
  }, [isDragging])

  // console.log(type, ' - ', renderedHeight);
  // console.log('renderedHeight :', renderedHeight, 'type :', type);
  return (
    <div ref={dragHandle ? null : drag} style={
      {...verticalHandle ? componentStyle_vertical : componentStyle, height: contentHeight ? contentHeight : null, minWidth: contentWidth ? contentWidth : null}}>
      <div ref={dragContentRef}>
        {
          !isDragging ? (
            renderContent({...props, drag: drag, preview: preview, dragContentRef: dragContentRef})
          ) : (
            <div style={{height: renderedHeight ? renderedHeight : _renderedHeight, lineHeight: renderedHeight ? renderedHeight : _renderedHeight, borderRadius: 10, backgroundColor:'lightgrey'}}></div>
            // <div ref={dragContentRef} style={{height: contentHeight ? contentHeight: renderedHeight ? renderedHeight : 24, lineHeight: contentHeight ? contentHeight: renderedHeight ? renderedHeight : 24, borderRadius: 10, backgroundColor:'lightgrey'}}></div>
          )
        }
      </div>
    </div>
  )
}

const renderContent = (props) => {
  const { dragHandle, drag, preview, verticalHandle, handleWrapCSS, contentWrapCSS, verticalLeftAreaCSS, dragContentRef, disableDrag } = props
  if (dragHandle) {
    return (
      <div ref={preview} style={{...!verticalHandle ? verticalLeftAreaCSS ? verticalLeftAreaCSS : draggable_component_wrap_style : {}, cursor: disableDrag && disableDrag !== undefined ? 'not-allowed' : 'cell'}}>
        <div ref={drag} style={{paddingLeft: 14, paddingRight: 14, ...handleWrapCSS, pointerEvents: disableDrag ? 'none' : 'inherit'}}>
          {dragHandle}
          <div style={{padding: '5px 0px'}}>
          </div> 
        </div>
        <div style={{cursor: 'default', paddingLeft: 5, paddingRight: 5, ...contentWrapCSS}}>
          {props.children}
        </div>
      </div>
    )
  }
  return (
    <React.Fragment>
      {props.children}
    </React.Fragment>
  )
}
const draggable_component_wrap_style = {
  display: 'grid',
  gridTemplateColumns: '30px calc(100% - 30px)',
}

const componentStyle_vertical = {
  display: 'inline-block',
  verticalAlign: 'top',
  borderRadius: 7.5,
  cursor: 'move',
  transition: '0.15s',
  overflow: 'visible',
  wordBreak: 'break-all',
  opacity: 1
}
const componentStyle = {
  // lineHeight: '24px',
  verticalAlign: 'middle',
  borderRadius: 7.5,
  // boxShadow: '0px 0px 3px 1px lightgrey',
  // padding: '2.5px 5px',
  // marginBottom: 9,
  // userSelect: 'none',
  cursor: 'move',
  transition: '0.15s',
  // backgroundColor: isDragging ? '#1085c5' : 'transparent',
  // color: isDragging ? 'white' : 'black',
  overflow: 'visible',
  wordBreak: 'break-all',
  opacity: 1,
  // fontWeight: 'bold',
}

export default DraggableComponent